// @flow
import {
  TREATMENT_DETAILS_REQUEST,
  TREATMENT_DETAILS_ERROR,
  TREATMENT_DETAILS_UPDATE,
  TREATMENT_DETAILS_RESET
} from './constants';

import type {
  Action, Treatment, CompanyPlace, Photo
} from '../types';

export const requestTreatmentDetails = (slug: string): Action => ({
  type: TREATMENT_DETAILS_REQUEST,
  slug
});

export const errorTreatmentDetails = (error: Error): Action => ({
  type: TREATMENT_DETAILS_ERROR,
  error
});

export const updateTreatmentDetails = (
  data: Treatment,
  included: Array<CompanyPlace | Photo>
): Action => ({
  type: TREATMENT_DETAILS_UPDATE,
  data,
  included
});

export const resetTreatmentDetails = (): Action => ({ type: TREATMENT_DETAILS_RESET });
